var _metadata, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "174.000000pt",
    height: "66.000000pt",
    viewBox: "0 0 174.000000 66.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,66.000000) scale(0.100000,-0.100000)",
    fill: "#ff000f",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172 507 c-29 -83 -52 -155 -52 -159 0 -5 45 -8 100 -8 l100 0 0 160 0 160 -47 0 -48 0 -53 -153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 500 l0 -160 100 0 c55 0 100 3 100 8 0 4 -23 76 -52 159 l-53 153 -47 0 -48 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 500 l0 -160 100 0 100 0 0 160 0 160 -100 0 -100 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 500 l0 -160 108 0 107 1 -35 32 -35 33 22 33 c27 40 30 108 8 152 -23 43 -71 69 -127 69 l-48 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 500 l0 -160 100 0 100 0 0 160 0 160 -100 0 -100 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 500 l0 -160 108 0 107 1 -35 32 -35 33 22 33 c27 40 30 108 8 152 -23 43 -71 69 -127 69 l-48 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 167 c-29 -83 -52 -155 -52 -159 0 -5 40 -8 88 -8 l88 0 23 70 22 70 50 0 49 0 0 90 0 90 -107 0 -108 0 -53 -153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 231 l0 -90 52 -3 51 -3 22 -65 22 -65 90 -3 90 -3 -56 161 -56 160 -107 0 -108 0 0 -89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 160 l0 -160 100 0 100 0 0 160 0 160 -100 0 -100 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 160 l0 -160 45 0 c77 0 145 42 181 113 21 41 28 115 15 165 l-12 42 -114 0 -115 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 160 l0 -160 100 0 100 0 0 160 0 160 -100 0 -100 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 160 l0 -160 45 0 c77 0 145 42 181 113 21 41 28 115 15 165 l-12 42 -114 0 -115 0 0 -160z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7eefa2843bccde99e53a16a56c7e4bee.svg";
export { ForwardRef as ReactComponent };